import { ACTIONS } from "../../enums/actions";

export const setClientOptions = (payload: any,  onSuccess: Function | null = null, onFail: Function | null = null) => ({
    type: ACTIONS.SET_CLIENT_OPTIONS,
    payload,
    onSuccess: onSuccess || null,
    onFail: onFail || null
});
